import periodReportTemplate from './periodReport.html';

class ReportsController {
  static $inject = [
    '$state',
    '$stateParams',
    '$filter',
    'CalendarService',
    'PeriodReport',
  ];

  me: any;
  period: string;
  selected: { year: number; organizationId: any; month?: number };
  years: number[];
  months: number[];
  monthsLabels: string[];
  periodReports: any[];
  completed: string;
  orderColumn: string;

  constructor(
    private $state,
    private $stateParams,
    private $filter,
    private CalendarService,
    private PeriodReport,
  ) {}

  $onInit() {
    const now = new Date();

    this.period = this.$stateParams.period;

    const organization =
      this.me.organizations[this.me.organizations.length - 1];
    this.selected = {
      year: now.getFullYear(),
      organizationId: organization.id,
    };

    this.years = this.CalendarService.getYears();
    this.months = this.CalendarService.getMonths();
    this.monthsLabels = this.CalendarService.getMonthsLabels();

    if (this.period === 'monthly') {
      this.selected.month = now.getMonth() + 1;
    }

    this.refreshReport();
  }

  private notCompletes(report) {
    const uncompleted = this.$filter('filter')(report, function (value) {
      return value.absences + value.joursTravailles < value.total;
    });

    return uncompleted;
  }

  refreshReport() {
    this.PeriodReport.query(this.selected).then((report) => {
      this.periodReports = report;
      this.completed =
        report.length -
        this.notCompletes(report).length +
        '/' +
        report.length;
    });
  }

  order(orderColumn) {
    if (this.orderColumn && this.orderColumn.indexOf('+') === 0) {
      this.orderColumn = '-' + orderColumn;
    } else {
      this.orderColumn = '+' + orderColumn;
    }
  }

  gotoTimesheet(memberId) {
    const year = this.selected.year || moment().year();
    //Take the first week of the month
    const week = moment({
      year: year,
      month: (this.selected.month || 1) - 1,
      day: 1,
    }).weeks();

    this.$state.go('app.timesheet.weekly', {
      userId: memberId,
      year: this.selected.year,
      week: week,
    });
  }
}

export const PeriodReportComponent = {
  template: periodReportTemplate,
  bindings: {
    me: '<',
  },
  controller: ReportsController,
};
